import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './components/dialog/dialog.component';
import { StoreModule } from '@ngrx/store';
import * as fromDialog from './features/dialog.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DialogEffects } from './features/dialog.effects';
import { ImportModule } from '../import/import.modue';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { createCustomElement } from '@angular/elements';
import { ImportTablesModule } from '../import-tables/import-tables.module';
import { ImportChampionsModule } from '../import-champions/import-champions.module';



@NgModule({
  declarations: [DialogComponent],
  imports: [
    CommonModule,
    ImportModule,
    ImportTablesModule,
    ImportChampionsModule,
    StoreModule.forFeature(fromDialog.dialogFeatureKey, fromDialog.reducer),
    EffectsModule.forFeature([DialogEffects]),
    MdbModalModule
  ],
  exports: [DialogComponent]
})
export class DialogModule {
  constructor(injector: Injector) {
    const DialogElement = createCustomElement(DialogComponent, {injector});

    try {
      customElements.define('paybee-dialog-element', DialogElement);
    } catch(e) {}
  }
}
